import { createApp } from 'vue';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App.vue';
import { readSearchAppConfig } from './utils/config';
import './styles/search-app.css';

const element = document.getElementById('search-app');
if (element) createApp(App, { config: readSearchAppConfig(element) }).mount(element);
